export type EsgPai = {
  greenhouseGases: boolean
  biodiversity: boolean
  waterPollution: boolean
  hazardousWaste: boolean
  humanRights: boolean
  genderEquality: boolean
}

export const indicatorEsgLabel = {
  NEUTRAL: 'neutral',
  MODERATE: 'moderate',
  SIGNIFICANT: 'significant',
  HIGH: 'high',
}

export type IndicatorEsgLabel = ValueOf<typeof indicatorEsgLabel>

export type EsgSfdrTaxonomy = {
  label: IndicatorEsgLabel
  value: number
}

export const ESG_PREFERENCES = {
  GENERIC: 'generic',
  CUSTOM: 'custom',
  NEUTRAL: 'neutral',
  NONE: 'none',
} as const

export const ESG_PROFILES = {
  NEUTRAL: 'neutral',
  INVOLVED: 'involved',
  RESPONSIBLE: 'responsible',
  COMMITTED: 'committed',
  NONE: 'none',
} as const

export const ESG_PATHS = {
  GENERIC: 'generic',
  PERSONALIZED: 'personalized',
  NEUTRAL: 'neutral',
} as const

export type EsgPreference = ValueOf<typeof ESG_PREFERENCES>
export type EsgProfile = ValueOf<typeof ESG_PROFILES>
export type EsgPath = ValueOf<typeof ESG_PATHS>

type BaseEsgParagraphsRequirement = { esgPath: EsgPath }
type SfdrParagraphsRequirement =
  | { hasSfdr: false }
  | { hasSfdr: true; sfdrValue: number }
type TaxonomyParagraphsRequirement =
  | { hasTaxonomy: false }
  | { hasTaxonomy: true; taxonomyValue: number }
type PaiParagraphsRequirement = { hasPai: boolean }

export type EsgParagraphsRequirements = BaseEsgParagraphsRequirement &
  SfdrParagraphsRequirement &
  TaxonomyParagraphsRequirement &
  PaiParagraphsRequirement

export type EsgParagraph = { key: string; percentageValue?: number }
